/**
 * BypassModeBanner - Banner shown when in project restoration/bypass mode
 *
 * Indicates that saved design is being displayed directly without polygon fetch.
 */

import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface BypassModeBannerProps {
  show: boolean;
}

export function BypassModeBanner({ show }: BypassModeBannerProps) {
  if (!show) return null;

  return (
    <div className="p-3 bg-blue-50 border-b-2 border-blue-200">
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 text-blue-600 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-blue-800">
          <strong>Project Restoration Mode:</strong> Showing saved design directly. Polygon boundaries hidden for clarity.
        </p>
      </div>
    </div>
  );
}

export default BypassModeBanner;
